import React, { Component } from 'react';
import { DialogActions, Button, MenuItem, TextField, DialogContent, DialogTitle, Dialog, CircularProgress, Box } from '@material-ui/core';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import PasswordField from '../../shared/components/PasswordField';
import userService from '../../api/userService';
import PhoneNumberField from '../../shared/components/PhoneNumberField';
import { cleanUser } from '../../redux/actions/usersActions';
import { getSelectOptions } from '../../shared/helpers/selectHelper';
import ZipCodeField from '../../shared/components/ZipCodeField';

class NewAdministratorForm extends Component {
    constructor(props) {
        super(props);
        this.state = {
            id: null,
            fullName: '',
            email: '',
            phoneNumber: '',
            zipCode: '',
            password: '',
            role: 'ADMINISTRATOR',
            idCompany: '',
            countryCode: '+1', // Default country code
            isLoading: false
        };

        this.changeFullname = this.changeFullname.bind(this);
        this.changeEmail = this.changeEmail.bind(this);
        this.changePhoneNumber = this.changePhoneNumber.bind(this);
        this.changeZipCode = this.changeZipCode.bind(this);
        this.changePassword = this.changePassword.bind(this);
        this.changeRole = this.changeRole.bind(this);
        this.changeCompany = this.changeCompany.bind(this);
        this.closeModal = this.closeModal.bind(this);
        this.addAdministrator = this.addAdministrator.bind(this);
        this.updateAdministrator = this.updateAdministrator.bind(this);
        this.setUserDetails = this.setUserDetails.bind(this);
        this.handleCountryCodeChange = this.handleCountryCodeChange.bind(this);
    }

    setUserDetails() {
        if (this.props.selectedUser) {
            const { id, fullName, email, phoneNumber, zipCode, idCompany, Role, role } = this.props.selectedUser;
            
            // Extract country code from existing phone number if it exists
            let extractedCountryCode = '+1'; // default
            let cleanPhoneNumber = phoneNumber || '';
            
            if (phoneNumber) {
                // Check for common country codes and extract them
                const countryCodes = ['+598', '+55', '+56', '+54', '+52', '+1'];
                for (const code of countryCodes) {
                    if (phoneNumber.startsWith(code)) {
                        extractedCountryCode = code;
                        cleanPhoneNumber = phoneNumber.substring(code.length);
                        break;
                    }
                }
            }
            
            this.setState({
                id,
                fullName,
                email,
                phoneNumber: cleanPhoneNumber,
                zipCode,
                idCompany,
                role: Role || role || (Boolean(idCompany) ? 'COMPANY' : 'ADMINISTRATOR'),
                countryCode: extractedCountryCode,
                isLoading: false
            });
        } else {
            this.setState({
                id: null,
                fullName: '',
                email: '',
                phoneNumber: '',
                zipCode: '',
                role: 'ADMINISTRATOR',
                idCompany: '',
                countryCode: '+1',
                isLoading: false
            });
        }
    }

    closeModal() {
        this.setState({ isLoading: false });
        this.props.cleanUser();
        this.props.hideForm();
    }

    changeFullname(evt) {
        this.setState({
            fullName: evt.target.value
        });
    }

    changeEmail(evt) {
        this.setState({
            email: evt.target.value
        });
    }

    changePhoneNumber(evt) {
        this.setState({
            phoneNumber: evt.target.value
        });
    }

    changeZipCode(evt) {
        this.setState({
            zipCode: evt.target.value
        });
    }

    changePassword(evt) {
        this.setState({
            password: evt.target.value
        });
    }

    changeCompany(evt) {
        this.setState({
            idCompany: evt.target.value
        });
    }

    changeRole(evt) {
        this.setState({
            role: evt.target.value
        });
    }

    addAdministrator() {
        this.setState({ isLoading: true });
        const { fullName, email, phoneNumber, zipCode, password, role, idCompany, countryCode } = this.state;
        const formattedPhoneNumber = countryCode + phoneNumber.replace(/[^0-9]/g, '');
        userService.addUser(fullName, email, formattedPhoneNumber, zipCode, password, role, idCompany)
            .then(() => {
                this.setState({ isLoading: false });
                this.closeModal();
            })
            .catch(() => {
                this.setState({ isLoading: false });
            });
    }

    updateAdministrator() {
        this.setState({ isLoading: true });
        const { id, fullName, email, zipCode, phoneNumber, countryCode } = this.state;
        const formattedPhoneNumber = countryCode + phoneNumber.replace(/[^0-9]/g, '');
        userService.updateUser(id, fullName, email, formattedPhoneNumber, zipCode)
            .then(() => {
                this.setState({ isLoading: false });
                this.closeModal();
            })
            .catch(() => {
                this.setState({ isLoading: false });
            });
    }

    handleCountryCodeChange(evt) {
        this.setState({
            countryCode: evt.target.value
        });
    }

    render() {
        const { showModal, companies } = this.props;
        const { id, fullName, email, phoneNumber, zipCode, password, role, idCompany, countryCode, isLoading } = this.state;
        const isEditing = Boolean(id);
        const isCompany = role === 'COMPANY';
        return (
            <Dialog onRendered={() => {
                this.setUserDetails();
            }} open={showModal} onClose={this.closeModal} aria-labelledby="form-dialog-title">
                <DialogTitle id="form-dialog-title">{isEditing ? `Editing ${fullName}'s details` : "Add new Administrator"}</DialogTitle>
                <DialogContent>
                    {isLoading && (
                        <Box display="flex" justifyContent="center" alignItems="center" p={3}>
                            <CircularProgress size={40} />
                            <Box ml={2}>
                                <span>Updating user data...</span>
                            </Box>
                        </Box>
                    )}
                    {!isLoading && (
                        <>
                    <TextField
                        autoFocus
                        variant="outlined"
                        margin="normal"
                        id="name"
                        label="Administrator's name"
                        type="text"
                        onChange={this.changeFullname}
                        value={fullName}
                        fullWidth
                    />
                    <TextField
                        margin="normal"
                        id="name"
                        variant="outlined"
                        label="E-mail address"
                        type="text"
                        onChange={this.changeEmail}
                        value={email}
                        fullWidth
                    />
                    <div style={{ display: 'flex', alignItems: 'center' }}>
                        <TextField
                            select
                            variant="outlined"
                            margin="normal"
                            label="Country Code"
                            value={countryCode}
                            onChange={this.handleCountryCodeChange}
                            style={{ flex: '0 0 160px', marginRight: '8px' }} // Aumentar o flex-basis para 120px
                        >
                            <MenuItem value="+1">USA (+1)</MenuItem>
                            <MenuItem value="+55">Brazil (+55)</MenuItem>
                            <MenuItem value="+52">Mexico (+52)</MenuItem>
                            <MenuItem value="+56">Chile (+56)</MenuItem>
                            <MenuItem value="+54">Argentina (+54)</MenuItem>
                            <MenuItem value="+598">Uruguay (+598)</MenuItem>
                        </TextField>
                        <TextField
                            margin="normal"
                            id="name"
                            variant="outlined"
                            label="Phone Number"
                            InputLabelProps={{ shrink: true }}
                            type="text"
                            InputProps={{ 
                                inputComponent: PhoneNumberField,
                                inputProps: { countryCode: countryCode }
                            }}
                            onChange={this.changePhoneNumber}
                            value={phoneNumber}
                            style={{ flex: '1 0 auto' }}
                        />
                    </div>

                    <TextField
                        margin="normal"
                        id="name"
                        variant="outlined"
                        label="Zip Code"
                        InputLabelProps={{ shrink: true }}
                        type="text"
                        InputProps={{ inputComponent: ZipCodeField }}
                        onChange={this.changeZipCode}
                        value={zipCode}
                        fullWidth
                    />
                    <TextField
                        select
                        margin="normal"
                        id="role"
                        variant="outlined"
                        label="Role"
                        InputLabelProps={{ shrink: true }}
                        type="text"
                        onChange={this.changeRole}
                        value={role}
                        fullWidth
                        disabled={isEditing}
                    >
                        {getSelectOptions([{ value: 'COMPANY', display: 'Company user' }, { value: 'ADMINISTRATOR', display: 'Backoffice\'s Administrator' }])}
                    </TextField>
                    {
                        isCompany && !isEditing ?
                            <TextField
                                select
                                margin="normal"
                                id="company"
                                variant="outlined"
                                label="Company"
                                InputLabelProps={{ shrink: true }}
                                type="text"
                                onChange={this.changeCompany}
                                value={idCompany}
                                fullWidth
                            >
                                {getSelectOptions(companies.map((comp) => ({ value: comp.id, display: comp.name })))}
                            </TextField>
                            :
                            null
                    }
                    {
                        isEditing ?
                            null
                            :
                            <PasswordField
                                margin="normal"
                                id="password"
                                variant="outlined"
                                label="Password"
                                onChange={this.changePassword}
                                value={password}
                                helperText="Your password must have a minimum of 8 characters, 1 uppercase letter, 1 lowercase letter and 1 digit."
                                fullWidth={true} />
                    }
                        </>
                    )}
                </DialogContent>
                <DialogActions>
                    <Button onClick={this.closeModal} color="primary" disabled={isLoading}>
                        Back
                    </Button>
                    <Button 
                        onClick={isEditing ? this.updateAdministrator : this.addAdministrator} 
                        color="primary"
                        disabled={isLoading}
                        startIcon={isLoading && <CircularProgress size={20} />}
                    >
                        {isLoading ? 'Processing...' : (isEditing ? "Save" : "Add")}
                    </Button>
                </DialogActions>
            </Dialog>
        );
    }
}

const mapStateToProps = ({ userState, companyState }) => ({
    selectedUser: userState.selectedUser,
    companies: companyState.companies
});

const mapDispatchToProps = dispatch => (
    bindActionCreators({ cleanUser }, dispatch)
);

export default connect(mapStateToProps, mapDispatchToProps)(NewAdministratorForm);
